import React from "react";
import "./style.css";

const UnderlinedTextField = ({
  placeholder = "Enter text",
  svgSrc,
  value = "",
  onChange,
  type = "text",
  trailingIcon = null, // New prop
}) => {
  const hasValue = !!value;

  return (
    <div className={`underlined-text-field ${hasValue ? "active" : ""}`}>
      <div className="icon-wrapper">
        {svgSrc && (
          <div
            className="icon_utf"
            style={{
              maskImage: `url(${svgSrc})`,
              WebkitMaskImage: `url(${svgSrc})`,
            }}
          />
        )}
      </div>

      <input
        type={type}
        className="text-input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
      />

      {trailingIcon && <div className="trailing-icon">{trailingIcon}</div>}
    </div>
  );
};

export default UnderlinedTextField;
